<template>
  <div>
        <div class="gap pc"></div>
     <div class=" gap-mob"></div>
    <div class="pc">
      
      <div class="top-box">
        <el-header class="heade_box" :class="[{ heade_box_active: msg }]">
          <div class="heade_left f-l">
            <router-link to="/home" class="logo">logo</router-link>
          </div>
          <div class="heade_right f-r">
            <div
              v-for="item of navigationArr"
              :key="item.id"
              
              class="heade_right_item"
              :class="{ act: item.act }"
            >
              <router-link  @click="changeNav(item)" :to="item.link">{{ item.name }}</router-link>
              <span></span>
            </div>
          </div>
        </el-header>
      </div>
    </div>
    <div class="mob">
     
      <div>
        <div class="nav-mob-logo"><img src="../../assets/images/xdt-logo.png" alt="" /></div>
        <a href="javascript:;" >
          <div class="nav-mob-btn" :class="{act: mobNavFlag}" @click="openNav"></div>
        </a>
      </div>
      <div class="nav-mob-menu nav-mob-father"  v-if="mobNavFlag">
        <div class="act" @click="changeRoute('/home')">首页</div>
        <div  @click="changeRoute('/about')">关于我们</div>
        <div  @click="changeRoute('/serve')">服务内容</div>
        <div  @click="changeRoute('/project')">项目经验</div>
        <div  @click="changeRoute('/news?id=8,10,11&list=公司新闻,行业新闻,最新公告')">新闻资讯</div>
        <div  @click="changeRoute('/contact')">联系我们</div>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      navigationArr: [],
      mobNavFlag:false,
    };
  },
  watch: {
    "$route.path": {
      handler(newVal) {
        console.log(newVal);
        this.navigationArr.forEach((item, itemIdx) => {
          if (newVal == item.link) {
            console.log(item);
            item.act = true;
          } else {
            if (newVal.indexOf("id") != -1) {
              return;
            }

            // if(newVal.indexOf('list') != -1){
            //   console.log(1111111)
            //   item.act = true;
            // }

            item.act = false;

            if (newVal == "/news" && itemIdx == 4) {
              item.act = true;
            }
          }
        });
        // this.$set(itemInfo, "act", true);
      },
      immediate: true,
      deep: true,
    },
  },
  props: ["msg"],
  methods: {
    changeNav(itemInfo) {
      this.navigationArr.forEach((item) => {
        item.act = false;
      });
      this.$set(itemInfo, "act", true);
    },
    changeRoute(path){
      if(path == this.$route.path){
        this.mobNavFlag = false;
        return  
      }
      
      this.$router.push(path);
      this.mobNavFlag = false;
    },
    openNav(){
      this.mobNavFlag = !this.mobNavFlag
    }
  },
  created() {
    let params = new URLSearchParams();
    params.append("id", 1);
    this.$http
      .post("/sinocro/sinocroapi/classify", params)
      .then(({ data: res }) => {
        if (res.code !== 200) {
          return;
        }
        if (res.data.smallClassifyTree.length > 0) {
          res.data.smallClassifyTree.forEach((item) => {
            if (item.id == 1) {
              this.navigationArr.push({
                name: item.name,
                link: "/home",
                act: true,
              });
            } else if (item.id == 2) {
              this.navigationArr.push({
                name: item.name,
                link: "/about",
                act: false,
              });
            } else if (item.id == 3) {
              this.navigationArr.push({
                name: item.name,
                link: "/serve",
                act: false,
              });
            } else if (item.id == 4) {
              this.navigationArr.push({
                name: item.name,
                link: "/project",
                // link: "/project?id=" + item.id,
                act: false,
              });
            } else if (item.id == 5) {
              let idArr = [];
              let listArr = [];
              if (item.children.length > 0) {
                item.children.forEach((itemSon) => {
                  idArr.push(itemSon.id);
                });
                item.children.forEach((itemSon) => {
                  listArr.push(itemSon.name);
                });
              }
              this.navigationArr.push({
                name: item.name,
                link:
                  "/news?id=" + idArr.join(",") + "&list=" + listArr.join(","),
                act: false,
              });
            } else if (item.id == 6) {
              this.navigationArr.push({
                name: item.name,
                link: "/contact",
                act: false,
              });
            } 
            // else if (item.id == 14) {
            //   this.navigationArr.push({
            //     name: item.name,
            //     link: "/partners",
            //     act: false,
            //   });
            // }
          });
        }
        // window.SITE_CONFIG["dictList"] = res.data;
      })
      .catch(() => {});
  },
};
</script>

<style scoped>
.gap.pc {
  height: 100px;
  
}
.gap-mob{
  display: none;
}
.top-box {
  z-index: 999;
  transition: 1s all;
  background-color: rgba(255, 255, 255, 1);
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  height: 100px !important;
  line-height: 100px;
  width: 100%;
  padding: 0 15px;
  z-index: 999999;
}
.heade_box {
  z-index: 999;
  transition: 1s all;
  height: 100px !important;
  line-height: 100px;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 15px;
  z-index: 999999;
}

.heade_right {
  display: flex;
  margin-right: 10px;
}
.heade_right .heade_right_item {
  transition: 1s all;
  position: relative;
  /* cursor: pointer; */
  color: #fff;
  font-size: 16px;
  margin-left: 64px;
}
.heade_right .heade_right_item:hover {
  opacity: 0.7;
}
.heade_right .heade_right_item.act:hover {
  opacity: 1;
}
.heade_right .heade_right_item a {
  font-family: Source Han Sans CN;
  font-weight: bold;
}
.heade_right .heade_right_item.act a {
  color: #19a9ba;
}
.heade_right .heade_right_item:first-child {
  margin: 0;
}
.heade_right .heade_right_item.act span {
  display: block;
}
.heade_right .heade_right_item span {
  display: none;
  position: absolute;
  width: 100%;
  bottom: 23px;
  background: #19a9ba;
  height: 3px;
  left: 0;
}

.heade_right .heade_right_item a {
  color: #333;
  text-decoration: none;
  font-size: 20px;
  position: relative;
  padding-bottom: 5px;
}
.heade_left .logo {
  background-image: url(../../assets/images/xdt-logo.png);
  background-repeat: no-repeat;
  background-size: contain;
  color: rgba(0, 0, 0, 0);
  display: inline-block;
  width: 228px;
  height: 48px;
  top: 26px;
  pointer-events: auto;
  position: relative;
  text-indent: -999px;
}
.mob {
  display: none;
}

@media only screen and (max-width: 768px) {
  .pc {
    display: none;
  }
  .mob {
    z-index: 9999;
    display: block;
    position: fixed;
    top: 0;
    width: 100%;
    
  }
  .mob > div{
    background-color: #fff;
    width: 100%;
    height: 60px;
  }
  .gap.pc{
    display: none;
  }
  .gap-mob {
    height: 60px;
    width: 100%;
    display: block;
  }
  .nav-mob-logo {
    float: left;
    width: 166px;
    box-sizing: border-box;
    padding-top: 16px;
    padding-left: 16px;
  }
  .nav-mob-logo img {
    width: 100%;
  }
  .nav-mob-btn {
    float: right;
    width: 40px;
    height: 40px;
    margin-top: 12px;
    transform: scale(0.5);
    background-image: url(../../assets/images/sprite-two.png);
    background-position: -16px -87px;
  }
  .nav-mob-btn.act {
    background-position: -16px -20px;
  }

  .nav-mob-menu > div {
    position: relative;
    box-sizing: inherit;
    padding-left: 15px;
    height: 34px;
    line-height: 34px;
    color: #fff;
    border-bottom: 1px solid #224b8d;
    background-color: rgba(23, 62, 127, 0.5);
  }
  .nav-mob-menu > div::after {
    transform: scale(0.5);
    position: absolute;
    right: 0;
    content: "";
    float: right;
    width: 42px;
    height: 42px;
    float: right;
    background-image: url(../../assets/images/sprite-two.png);
    background-position: -21px -154px;
  }

  .nav-mob-children .nav-mob-menu > div::after {
    display: none;
  }
  .nav-mob-children a {
    color: #fff;
  }
  .nav-mob-btn {
    float: right;
    width: 40px;
    height: 40px;
    margin-top: 12px;
    transform: scale(0.5);
    background-image: url(../../assets/images/sprite-two.png);
    background-position: -16px -87px;
  }
  .nav-mob-btn.act {
    background-position: -16px -20px;
  }
  .nav-mob-menu > div {
    position: relative;
    box-sizing: inherit;
    padding-left: 15px;
    height: 34px;
    line-height: 34px;
    color: #fff;
    border-bottom: 1px solid #224b8d;
    background-color: rgba(23, 62, 127, 0.5);
  }
  .nav-mob-menu > div::after {
    transform: scale(0.5);
    position: absolute;
    right: 0;
    content: "";
    float: right;
    width: 42px;
    height: 42px;
    float: right;
    background-image: url(../../assets/images/sprite-two.png);
    background-position: -21px -154px;
  }

  .nav-mob-children .nav-mob-menu > div::after {
    display: none;
  }
  .nav-mob-children a {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Navigation.vue